
  // SPLASH
  function closeSplash() {
    const splash = document.getElementById('splash');
    splash.style.animation = 'none';
    splash.style.opacity = '0';
    splash.style.pointerEvents = 'none';
    document.getElementById('site').style.animation = 'none';
    document.getElementById('site').style.opacity = '1';
  }
  setTimeout(() => {
    document.getElementById('site').style.animation = 'none';
    document.getElementById('site').style.opacity = '1';
  }, 4200);

  // PAGE NAV
  function showPage(id) {
    document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
    const el = document.getElementById('page-' + id);
    if (el) { el.classList.add('active'); window.scrollTo(0,0); }
  }
  function showShopFilter(cat) {
    showPage('shop');
    setTimeout(() => filterShop(cat, document.querySelector('.filter-btn')), 50);
  }

  // CAROUSEL
  let currentSlide = 0;
  const totalSlides = 3;
  function moveCarousel(dir) {
    currentSlide = (currentSlide + dir + totalSlides) % totalSlides;
    updateCarousel();
  }
  function goToSlide(n) { currentSlide = n; updateCarousel(); }
  function updateCarousel() {
    document.getElementById('carouselSlides').style.transform = `translateX(-${currentSlide * 100}%)`;
    document.querySelectorAll('.dot').forEach((d,i) => d.classList.toggle('active', i === currentSlide));
  }
  setInterval(() => moveCarousel(1), 5000);

  // SHOP FILTER
  function filterShop(cat, btn) {
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('#shopGrid .product-card').forEach(card => {
      card.style.display = (cat === 'all' || card.dataset.cat === cat) ? 'block' : 'none';
    });
    document.querySelectorAll('.filter-btn').forEach(b => {
      if (b.textContent.toLowerCase().includes(cat) || cat === 'all' && b.textContent === 'All') b.classList.add('active');
    });
  }

  // WHOLESALE ORDER
  let wsQty = 1;
  let wsCostPerCase = 150;
  let wsRetailPerCase = 300;
  function selectArrangement(type) {
    if (type === 'upfront') {
      wsCostPerCase = 150; wsRetailPerCase = 300;
      document.getElementById('btnUpfront').classList.add('active');
      document.getElementById('btnConsign').classList.remove('active');
    } else {
      wsCostPerCase = 180; wsRetailPerCase = 300;
      document.getElementById('btnConsign').classList.add('active');
      document.getElementById('btnUpfront').classList.remove('active');
    }
    updatePrice();
  }
  function changeQty(dir) {
    wsQty = Math.max(1, wsQty + dir);
    document.getElementById('qtyDisplay').value = wsQty;
    document.getElementById('unitsLabel').textContent = '= ' + (wsQty * 12) + ' units';
    updatePrice();
  }
  function updatePrice() {
    const total = wsQty * wsCostPerCase;
    const retail = wsQty * wsRetailPerCase;
    const profit = retail - total;
    document.getElementById('priceTotal').textContent = '$' + total.toFixed(2);
    document.getElementById('priceBreak').textContent = wsQty + ' case' + (wsQty>1?'s':'') + ' × $' + wsCostPerCase + ' = $' + total.toFixed(2);
    document.getElementById('retailCalc').textContent = 'Retail value: $' + retail.toFixed(2) + ' · Profit: $' + profit.toFixed(2);
  }

  // ===== AJAX ADD TO CART (stay on page, show toast instead of redirecting to /cart) =====
  function opyneyeAjaxAddToCart(formEl) {
    if (!formEl) return;
    try {
      var fd = new FormData(formEl);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
        .then(function () {
          var toast = document.getElementById('cart-toast');
          if (toast) {
            toast.classList.add('show');
            clearTimeout(window._opyneyeToastTimer);
            window._opyneyeToastTimer = setTimeout(function () { toast.classList.remove('show'); }, 3000);
          }
        })
        .catch(function () { formEl.submit(); });
    } catch (e) {
      formEl.submit();
    }
  }

  // ===== OPYNEYE WHOLESALE LEAD TRACKING (v44) =====
  // Publishes events the custom pixel listens for. Safe no-op on pages
  // without the form. Does not touch Wholesale Gorilla's own files.
  document.addEventListener('DOMContentLoaded', function () {
    var wsForm = document.getElementById('wsg-signup');
    if (!wsForm || !window.Shopify || !Shopify.analytics) return;

    // Fires when a retailer actually submits the application
    wsForm.addEventListener('submit', function () {
      try {
        var company = (document.getElementById('company') || {}).value || '';
        Shopify.analytics.publish('wholesale_form_submitted', {
          company: company,
          page: window.location.pathname
        });
      } catch (e) { /* never block the real submission */ }
    });

    // Fires once when someone starts filling the form (first field focus)
    var started = false;
    wsForm.addEventListener('focusin', function () {
      if (started) return;
      started = true;
      try {
        Shopify.analytics.publish('wholesale_form_started', {
          page: window.location.pathname
        });
      } catch (e) {}
    });
  });
